<template>
  <v-row>
    <v-col cols="12">
      <h2>Downloads</h2>
    </v-col>

    <v-col cols="12">


      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-if="developmentData.files.length > 0"
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="developmentData.files"
          :search="search"
          no-data-text="No files available"
          item-key="name"
          class="elevation-1"
        >
          <template #item.file_name="{ value, item }">
            <v-chip
              v-if="!isDownloaded(item.id, item.is_downloaded)"
              color="#EB6B40"
              dark
              small
            >
              New
            </v-chip>
            {{ value }}
          </template>
          <template #item.id="{ value, item }">

            <v-btn
              x-small
              :loading="downloadLoading"
              :disabled="downloadLoading"
              color="blue-grey"
              class="ma-2 white--text"
              fab
              @click="downloadFile(value, item.file_name)"
            >
              <v-icon dark>
                mdi-cloud-download
              </v-icon>
            </v-btn>
          </template>
          <template #item.type="{ value }">
            <v-chip
              color="#5d3791"
              dark
              small
            >
              {{ attachmentName(value) }}
            </v-chip>

          </template>

        </v-data-table>
      </v-card>
    </v-col>


  </v-row>
</template>

<script>
import {get} from "vuex-pathify";
import {creditBilling} from "@/mixins/credit-billing";

export default {
  name: "CreditBillingSingleFiles",
  props: {
    id: String
  },
  mixins: [creditBilling],
  computed: {
    developmentData: get('creditBilling/development'),
  },
  data: () => ({
    fileTypes: {
      billing_review: 'Billing Review',
      tariffs: 'Tariffs',
      revised_bill: 'Revised Bill',
      referrals: 'Referrals',
      agreements: 'Agreements'
    },
    downloadLoading: false,
    search: '',
    downloadedFiles: [],
    headers: [
      {
        text: 'Type',
        align: 'start',
        value: 'type',
      },
      {text: 'File', value: 'file_name'},
      {text: 'Available', value: 'available_at'},
      {text: '', value: 'id'},
    ],
  }),
  methods: {
    attachmentName(value) {
      if (value in this.fileTypes) {
        return this.fileTypes[value];
      }

      return "Other";
    },
    isDownloaded(id, hasDownloaded) {
      return hasDownloaded || this.downloadedFiles.includes(id);
    },
    formatterDate(value, withoutTime) {
      if (!value) {
        return "";
      }
      return this.formatDate(value, true, !withoutTime);
    },
    async downloadFile(fileRef, name) {
      this.downloadLoading = true;

      if (await this.triggerCreditFileDownload("download", fileRef, name)) {
        this.downloadedFiles.push(fileRef);
      }

      this.downloadLoading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
